module.exports = __webpack_public_path__ + "static/media/fire.9e0e38b8.png";